import { useMemo } from "react";
import { Translation } from "components/Translations/Translation";
import { useGetTranslation } from "components/Translations/translationUtils";
import styles from '../multiSelect.module.scss';
import { Link } from "react-router-dom";
import { ArrowDownIcon } from "components/icons/icons";

type ArgType = {
	selectedItems
	getItemId(item: any): string | number
	getItemText(item: any): string
	getItemLinkRoute?(item: any): string
	isLink?: boolean
	count: number
	numOfItemNames: number
	expanded?: boolean
	size?: 'medium' | 'small'
	disabled?: boolean
}

export const useControlContent = ({
	selectedItems, getItemId, getItemText, getItemLinkRoute, count, numOfItemNames, isLink, expanded, size, disabled
}: ArgType) => {
	const getTranslation = useGetTranslation();

	const content = useMemo(
		() => {
			if (selectedItems.length === 0 ) {
				return '';
			}

			if (selectedItems.length === count) {
				return <Translation i18n='i18n.label.allItemsSelected' />
			}

			if (selectedItems.length > numOfItemNames) {
				return <Translation i18n='i18n.label.selectedItems' args={[selectedItems.length.toString()]}/>
			}

			return selectedItems.map((item, index) => (
				<span key={getItemId(item)}>
					{index > 0 && ", "}
					<div className={styles.inline_block} key={getItemId(item)}>
						{isLink && getItemLinkRoute ? (
							<Link className={styles.link} to={getItemLinkRoute(item)} target='_blank'>
								{getTranslation(getItemText(item))}
							</Link>
						) : getTranslation(getItemText(item))}
					</div>
				</span>
			))
		},
		[selectedItems, count, numOfItemNames, getItemId, isLink, getItemLinkRoute, getTranslation, getItemText]
	)

	return (
		<>
			<div className={`${styles.select} ${size === 'small' ? styles.small : ''} ${expanded ? styles.focus : ''} ${disabled ? styles.disabled : ''}`}>
				{content}
			</div>
			{/* arrow */}
			<div className={`${styles.arrow} ${size === 'small' ? styles.small : ''} ${disabled ? styles.arrow_disabled : ''}`}>
				<ArrowDownIcon width={8} height={8} fill='currentColor' />
			</div>
		</>
	)
}
